import React from 'react';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore'; // Removed setDoc as it's no longer used here
import { auth, db } from '../services/firebaseService';
import firebaseService from '../services/firebaseService'; // Still needed for getUserByUsername in CompleteProfileScreen
import { useNavigate } from 'react-router-dom'; // Import useNavigate

const GoogleSignInButton = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  const signInWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      console.log("Google Sign-in successful!", user);

      // Check if user document exists in Firestore
      const userDocRef = doc(db, 'users', user.uid);
      const userDocSnap = await getDoc(userDocRef);

      if (!userDocSnap.exists()) {
        console.log("New Google user. Redirecting to complete profile.");
        // Redirect to a profile completion screen for new users
        navigate('/complete-profile', {
          state: {
            user: {
              uid: user.uid,
              displayName: user.displayName,
              email: user.email,
              photoURL: user.photoURL,
            },
            isNewUser: true,
          },
        });
      } else {
        console.log("Existing Google user. User document already exists in Firestore.");
        // Existing user, let AuthContext handle the state update and navigation
      }

      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
    } catch (error) {
      const errorCode = error.code;
      const errorMessage = error.message;
      const email = error.customData?.email;
      const credential = GoogleAuthProvider.credentialFromError(error);
      console.error("Error during Google Sign-in:", errorMessage);
      // ... display error to user
    }
  };

  return (
    <button 
      onClick={signInWithGoogle} 
      className="google-signin-btn"
      aria-label="Sign in with Google"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        backgroundColor: 'white',
        border: '1px solid #ddd',
        borderRadius: '8px',
        cursor: 'pointer',
        width: '100%',
        minHeight: '44px'
      }}
    >
      <img 
        src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" 
        alt="Google logo" 
        style={{ width: '24px', height: '24px' }}
      />
    </button>
  );
};

export default GoogleSignInButton;
